var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 30.017,
    viewBox: "0 0 35 30.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3620.353 -1032.514)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3626.651,1032.514H3621.3a.946.946,0,0,0-.946.946v28.125a.946.946,0,0,0,.946.946h33.108a.946.946,0,0,0,.946-.946V1033.46a.946.946,0,0,0-.946-.946h-5.349m-1.892,0h-18.624m24.919,1.892v3.879h-31.216v-3.879Zm-31.216,26.233v-20.462h31.216v20.462Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3629.974,1051.1a3.367,3.367,0,1,1,3.381-3.366A3.377,3.377,0,0,1,3629.974,1051.1Zm0-5.315a1.948,1.948,0,1,0,1.962,1.949A1.957,1.957,0,0,0,3629.974,1045.789Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3635.3,1055.913h-10.659a.71.71,0,0,1-.674-.931,6.319,6.319,0,0,1,6-4.368h0a6.32,6.32,0,0,1,6,4.368.711.711,0,0,1-.674.931Zm-9.57-1.419h8.481a4.884,4.884,0,0,0-8.481,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3649.343,1046.926h-9.459a.709.709,0,1,1,0-1.418h9.459a.709.709,0,1,1,0,1.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3649.343,1050.71h-9.459a.709.709,0,1,1,0-1.419h9.459a.709.709,0,1,1,0,1.419Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00615c",
    d: "M3649.343,1054.494h-9.459a.71.71,0,1,1,0-1.419h9.459a.71.71,0,1,1,0,1.419Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolesIcon);
export default __webpack_public_path__ + "static/media/roles-icon.dcc1d99d76688a6fdc02dac224cd0c14.svg";
export { ForwardRef as ReactComponent };